import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getJsonGenerateForms } from '../modules/utils/ServicesUtils';

type Props = {
	code: string;
};

const useFormio = ({ code }: Props) => {
	const [formJSON, setFormJSON] = useState<any>({});

	useEffect(() => {
		if (code) {
			getFormIO();
		}
	}, [code]);

	const getFormIO = async () => {
		try {
			const { data } = await getJsonGenerateForms(code);
			if (!data?.data || !Object.keys(data?.data).length) return;
			const formJSON = JSON.parse(data?.data?.[code]);
			setFormJSON(formJSON);
		} catch (error) {
			console.error(error);
		}
	};

	return { formJSON };
};

export default useFormio;
